import { memo, InputHTMLAttributes, forwardRef } from 'react'

import classnames from 'classnames'

import InputFeedback from '../inputFeedback'
import FormSection from '../formSection'

import './textarea.scss'

interface Props extends InputHTMLAttributes<HTMLTextAreaElement> {
  label?: string,
  errorMessage?: string,
  hint?: string,
  hasError?: boolean,
  rows?: number
}

const Textarea = forwardRef<HTMLTextAreaElement, Props>(({
  className,
  hasError,
  name,
  errorMessage,
  hint,
  label,
  ...rest
}, forwardedRef) => {
  return (
    <FormSection htmlFor={name} label={label}>
      <textarea
        name={name}
        ref={forwardedRef}
        className={
          classnames(
            'hot-form__input',
            'textarea',
            className,
            { 'is-invalid': hasError }
          )
        }
        {...rest} />

      {
        (errorMessage || hint) && (
          <InputFeedback
            hint={hint}
            hasError={hasError}
            errorMessage={errorMessage} />
        )
      }
    </FormSection>
  )
}
)

export default memo(Textarea)
